// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0444d290","831":"92a6e79a"}[chunkId] + ".chunk.js";
};